import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportOrdemCompraUseCase } from "../../../presentation/useCases/read/get_report_ordem_compra_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportOrdemCompraUseCase
 */

export class GetReportOrdemCompraUseCase implements IGetReportOrdemCompraUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportOrdemCompra(
    idOrdemCompra: number,
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportOrdemCompra(
      requiredMimeType,
      idOrdemCompra,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `obra_checklist_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
